'use client';
import { useParams, useSearchParams } from 'next/navigation';

export const useQueryParams = () => {
  const searchParams = useSearchParams();
  const params = useParams();

  return {
    ...Object.fromEntries(searchParams?.entries() ?? []),
    ...params,
  };
};
